import {
  getCoreRowModel,
  getFacetedRowModel,
  getFacetedUniqueValues,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
  type TableOptions,
} from '@tanstack/react-table'

import { fuzzyFilterFn } from './helper'
import type { DataTableFilterField } from './types'

interface UseDataTableProps<TData>
  extends Omit<TableOptions<TData>, 'getCoreRowModel' | 'filterFns'> {
  filterFields?: DataTableFilterField<TData>[]
}

export function useDataTable<TData>({
  filterFields = [],
  ...props
}: UseDataTableProps<TData>) {
  const table = useReactTable({
    ...props,
    filterFns: {
      fuzzy: fuzzyFilterFn,
    },
    globalFilterFn: 'fuzzy',
    enableRowSelection: true,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFacetedRowModel: getFacetedRowModel(),
    getFacetedUniqueValues: getFacetedUniqueValues(),
  })

  return { table }
}
